import { useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core'

export const useProposalCardStyles = makeStyles(() => ({
  root: {
    border: '1px solid var(--color-ai-200)',
    background: 'linear-gradient(135deg, var(--color-ai-050) 0%, white 100%)',
    borderRadius: 'var(--border-radius-lg)',
    boxShadow: 'var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.05))',
    margin: '12px 0',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px'
  },
  title: {
    color: 'var(--color-ai-700)',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 600
  },
  summary: {
    color: 'var(--color-neutral-700)',
    fontSize: 'var(--text-size-xs)',
    fontFamily: 'var(--font-mono, monospace)',
    wordBreak: 'break-word'
  },
  reasoning: {
    color: 'var(--color-neutral-600)',
    fontSize: 'var(--text-size-xs)',
    fontStyle: 'italic',
    lineHeight: 1.5
  },
  divider: {
    height: '1px',
    background: 'var(--color-ai-200)',
    margin: '2px 0'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '6px'
  },
  applied: {
    border: '1px solid var(--color-success-300)',
    background: 'var(--color-success-050)'
  },
  appliedRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 600,
    color: 'var(--color-success-700)'
  },
  dismissed: {
    border: '1px dashed var(--color-neutral-300)',
    background: 'var(--color-neutral-050)'
  },
  dismissedRow: {
    fontSize: 'var(--text-size-xs)',
    fontStyle: 'italic',
    color: 'var(--color-neutral-500)'
  }
}))

export function useAutoApplyEffect ({ autoAccept, state, apply }) {
  const fired = useRef(false)
  useEffect(() => {
    if (autoAccept && state === 'pending' && !fired.current) {
      fired.current = true
      apply({ auto: true })
    }
  }, [autoAccept, state, apply])
}
